import { Fragment } from 'react';
import { EpicSection, SectionHeader } from '@/vdp/styles';
import Sections from '~/constants/sections';
import useIsInFeatureUpgradeExperiment from '~/hooks/vdp/useIsInFeatureUpgradeExperiment';
import { getStandoutTierCategories, getVehicleDetails } from '~/selectors';
import useSelector from '~/store/useSelector';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import AdditionalHighlights from './AdditionalHighlights';
import CategoryCard from './CategoryCard';
import FeaturesAndHighlights from './FeatureTourUpgrade/FeaturesAndHighlights';
import InstalledPackagesCard from './InstalledPackagesCard';
import { CategoryWrapper, Container } from './KeyFeatures.styles';
import useGetAdditionalHighlights from './useGetAdditionalHighlights';

function KeyFeatures() {
  const standoutCategories = useSelector(getStandoutTierCategories);
  const { installedPackages = [] } = useSelector(getVehicleDetails);
  const showInstalledPackages = installedPackages.length > 0;
  const additionalHighlights = useGetAdditionalHighlights();
  const shouldRender =
    standoutCategories.length > 0 || additionalHighlights.length > 0;

  const isInFeatureUpgradeExperiment = useIsInFeatureUpgradeExperiment();

  return shouldRender ? (
    <EpicSection
      id={Sections.KeyFeatures}
      data-nav-section={Sections.KeyFeatures}
    >
      {isInFeatureUpgradeExperiment ? (
        <FeaturesAndHighlights />
      ) : (
        <>
          <SectionHeader>Key Features</SectionHeader>

          <Container>
            <CategoryWrapper cardCount={standoutCategories.length}>
              {standoutCategories.map((category, index) => (
                <Fragment key={category.name}>
                  <CategoryCard category={category} index={index} />
                </Fragment>
              ))}
              {showInstalledPackages && <InstalledPackagesCard />}
            </CategoryWrapper>
            <AdditionalHighlights />
          </Container>
        </>
      )}
    </EpicSection>
  ) : null;
}

export default withErrorBoundary(
  KeyFeatures,
  undefined,
  undefined,
  Sections.KeyFeatures
);
